<template>
    <el-dialog
        title="新增节点"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form
            label-position="right"
            label-width="100px"
            :rules="rules"
            :model="info"
            ref="infoRef">
            <el-form-item label="节点名称:" prop="n_name">
                <el-input v-model="info.n_name" maxlength="15"></el-input>
            </el-form-item>
            <el-form-item label="节点类型:" prop="layer">
                <el-select v-model="info.layer" placeholder="请选择">
                    <el-option
                        v-for="(item, index) in layerList"
                        :key="index"
                        :label="item"
                        :value="index+1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关系名称:" prop="r_name" v-if="isAddEdge">
                <el-select v-model="info.r_name" placeholder="请选择">
                    <el-option
                        v-for="(item, index) in relationList"
                        :key="index"
                        :label="item"
                        :value="item"></el-option>
                </el-select>
                <!-- <el-input v-model="info.r_name" maxlength="10"></el-input> -->
            </el-form-item>
            <el-form-item label="节点链接:" prop="n_href">
                <el-input v-model="info.n_href" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="节点内容:">
                <el-input
                    type="textarea"
                    rows="5"
                    maxlength="250"
                    show-word-limit="show-word-limit"
                    v-model="info.content"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="reset">重 置</el-button>
            <el-button type="primary" @click="addNode">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "addNode",
        data() {
            return {
                dialogVisible: false,
                enterNode: {},
                isAddEdge: true,
                info: {
                    n_name: "",
                    content: "",
                    r_name: "",
                    n_href: "",
                    layer: ""
                },
                rules: {
                    n_name: [
                        {
                            required: true,
                            message: '请输入节点名称',
                            trigger: 'blur'
                        }
                    ],
                    r_name: [
                        {
                            required: true,
                            message: '请选择关系名称',
                            trigger: 'blur'
                        }
                    ],
                    n_href: [
                        {
                            message: "请检查链接格式",
                            pattern: '[http://|ftp://|https://|wmw]?[^\u4e00-\u9fa5\s]*?\.[com|net|cn|me|tw|fr][^' +
                                '\u4e00-\u9fa5\s]*'
                        }
                    ],
                    layer: [
                        {
                            required: true,
                            message: '请选择层级',
                            trigger: 'blur'
                        }
                    ]
                },
                // 关系列表
                relationList: [
                    "课节", "知识点", "前置知识点", "关联知识点"
                ],
                layerList: ["书", "课节", "知识点", "教学案例"]
            }
        },
        created() {},
        methods: {
            getNodeInfo(res) {
                this.dialogVisible = true
                if (res == "newNode") {
                    this.isAddEdge = false;
                    this.enterNode.layer = 0;
                    this.enterNode.note = "";
                } else {
                    this.enterNode = res;
                    this.isAddEdge = true;
                }

            },
            handleClose() {
                this.dialogVisible = false;
            },
            addNode() {
                this
                    .$refs['infoRef']
                    .validate((valid) => {
                        if (valid) {
                            // 新增节点
                            let node = {
                                name: this.info.n_name,
                                layer: this.info.layer != ""
                                    ? this.info.layer
                                    : this.enterNode.layer + 1,
                                note: this.enterNode.note,
                                content: this.info.content,
                                href: this.info.n_href
                            }

                            this
                                .$http
                                .post("/node/addNode", node)
                                .then((res) => {
                                    if (res.data._id != '' && this.isAddEdge) {
                                        this
                                            .$http
                                            .post("/node/addEdge", {
                                                f_node_id: this.enterNode.id,
                                                r_name: this.info.r_name,
                                                s_node_id: res.data._id
                                            })
                                            .then((res) => {
                                                this.isAddEdge = true;
                                            })
                                    }
                                    this.info.r_name = "";
                                    this.info.n_name = "";
                                    this.info.content = "";
                                    this.info.n_href = "";
                                    this.$emit("msg", "addNode")
                                    this.dialogVisible = false;
                                })
                        } else {
                            this
                                .$message
                                .error("请检查表单信息")
                            return false
                        }
                    });
            },
            // 表单重置
            reset() {
                this
                    .$refs['infoRef']
                    .resetFields();
            }
        }
    }
</script>

<style>
    .el-form-item {
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/subComponents/addNode.vue